import { BulkResponse } from "../../../../../data";
import {OrderDto, orderService} from "../../../../../domain";
import { ConfirmAllDto } from "../../../../../domain/dtos/actions/confirm-all";
import { OrderDeliveryPartners } from "../../../../../domain/dtos/actions/orders-delivery-partners";
import {OrderFormListener} from "../../order-form.props";

export const onConfirmAll = (confirmAllDto: ConfirmAllDto[]): Promise<BulkResponse[]| undefined> => {
    return orderService
        .confirmAll(confirmAllDto)
        .then(res => {
            return res;
        })
        .catch(() => {
            return undefined;
        });
}

export const getDeliveryPartnersForOrders = (orderIds: number[]): Promise<OrderDeliveryPartners[] | undefined> => {
    return orderService
        .getDeliveryPartnersForOrders(orderIds)
        .then(res => {
            return res;
        })
        .catch(() => {
            return undefined;
        });
}
